import { render, staticRenderFns } from "./ImpactedUniversities.vue?vue&type=template&id=7009dfcd&scoped=true&"
import script from "./ImpactedUniversities.vue?vue&type=script&lang=js&"
export * from "./ImpactedUniversities.vue?vue&type=script&lang=js&"
import style0 from "./ImpactedUniversities.vue?vue&type=style&index=0&id=7009dfcd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7009dfcd",
  null
  
)

export default component.exports